import { Box } from "@mui/material";
import { useUser } from "@/app/providers";
import React, { useEffect, useMemo } from "react";
import { CustomerDropdownAutoSave } from "@/features";
import { useCompanies, useUpdateProfile } from "@/hooks";
import { object } from "prop-types";
import type { SxProps, Theme } from "@mui/material/styles";

type CustomerSelectorProps = {
  sx?: SxProps<Theme>;
};

type CompanyRow = {
  id: string;
  name: string;
};

/**
 *
 */
export const CustomerSelector = (props: CustomerSelectorProps) => {
  const { user, setUser } = useUser();
  const { currentTeam, currentTenantId } = user || {};

  const allCompaniesVars = useMemo(() => {
    return currentTenantId === "all"
      ? { customerType: "parent" as const }
      : { customerId: "__none__" };
  }, [currentTenantId]);

  const userCompaniesVars = useMemo(() => {
    return currentTenantId && currentTenantId !== "all"
      ? { customerType: "parent" as const, tenantId: currentTenantId }
      : { customerId: "__none__" };
  }, [currentTenantId]);

  const { customers: allCompanies } = useCompanies(allCompaniesVars);
  const { customers: userCompanies } = useCompanies(userCompaniesVars);

  const companies = useMemo(() => {
    if (currentTenantId === "all") {
      return allCompanies;
    } else if (currentTenantId) {
      return userCompanies;
    }
    return [];
  }, [allCompanies, currentTenantId, userCompanies]);

  const boxSx = useMemo(() => {
    return {
      ...props.sx,
      ml: 2,
    };
  }, [props.sx]);

  const { updateProfile } = useUpdateProfile();

  useEffect(() => {
    if (companies?.length) {
      const foundRow = companies.find(
        (row: CompanyRow) => row.name === currentTeam,
      );
      if (!foundRow || !currentTeam) {
        const variables = {
          currentTeam: companies[0].name,
          currentTeamId: companies[0].id,
        };
        setUser((prev: any) => ({
          ...prev,
          ...variables,
        }));
        updateProfile(variables);
      }
    }
  }, [companies, currentTeam, setUser, updateProfile]);

  return (
    <Box sx={boxSx}>{companies.length > 0 && <CustomerDropdownAutoSave />}</Box>
  );
};

CustomerSelector.propTypes = {
  sx: object,
};
